import {SoggettoPratica} from "../../../../../../../common/models/tipologiche/soggetto-pratica";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {PropertiesSettings} from "../../../../../../../core/configuration/properties-settings";
import {Observable} from "rxjs";
import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {PraticaLight} from "../../../../../../../common/models/pratica/pratica-light";
import {distinctUntilChanged} from "rxjs/operators";
import { CreazionePraticaTipologicheService } from "../../../../services/creazione-pratica-tipologiche.service";
import {PraticaPenale} from "../../../../../../../common/models/pratica/pratica-penale";
import {TipoPratica} from "../../../../../../../common/models/tipologiche/tipo-pratica";
import {HelpersService} from "../../../../../../../core/services/helpers.service";
import {TipoTipologica} from "../../../../../../../common/models/tipologiche/tipo-tipologica";
import {TIPI_PRATICA} from "../../../../../../config/tipi-pratica.enum";
import { TipoVisibilita } from "src/app/common/models/tipologiche/tipo-visibilita";
import { AppData } from "src/app/data-store";
import { Codice } from "src/app/common/models/tipologiche/codice";


@Component({
  selector: 'app-dati-gen-pratica-form',
  templateUrl: './dati-gen-pratica-form.component.html',
  styleUrls: ['./dati-gen-pratica-form.component.css']
})
export class DatiGenPraticaFormComponent implements OnInit {

  @Input() set resetForm(input: boolean) {
    if(input && this.formGroup){
      this.formGroup.reset();
      if(this.tipoPratica && this.tipoPratica.endpoint === TIPI_PRATICA.PENALE) {
        this.addPraticaPenaleField();
      }
    }
  }
  @Input() pratica: PraticaLight | PraticaPenale;
  @Input() tipoPratica: TipoPratica;
  @Output() datiGeneraliChange: EventEmitter<PraticaLight | PraticaPenale> = new EventEmitter<PraticaLight | PraticaPenale>();
  @Output() valid: EventEmitter<boolean> = new EventEmitter<boolean>();
  formGroup: FormGroup;
  labelCreatoDaSistema = PropertiesSettings.LABEL_CREATO_DA_SISTEMA;
  soggettiOptions$: Observable<SoggettoPratica[]>;
  tipiReato$: Observable<TipoTipologica[]>;
  tipiPraticaEnum = TIPI_PRATICA;
  tipiVisibilitaOptions: TipoVisibilita[] = [];
  tipiVisibilitaDisabled = false;
  private codiceOptions: Codice[] = [];
  selectedCodice!: Codice | null;

  constructor(private formBuilder: FormBuilder,
              private tipologicheService: CreazionePraticaTipologicheService,
              private helpers: HelpersService
  ) {
    this.soggettiOptions$ = this.tipologicheService.getSocieta();
    this.tipiReato$ = this.helpers.getTipiReato();
    this.populateTipiVisibilita();
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      tipoVisibilita: [null],
      soggetto: [null],
      note: [''],
      oggetto: [''],
      codice: [null,Validators.required],
    });
    this.formGroup.valueChanges.pipe(distinctUntilChanged()).subscribe(value => {
      this.valid.emit(this.formGroup.valid);
      this.datiGeneraliChange.emit(value);
    });
    this.formGroup.patchValue({
      soggetto: this.pratica ? this.pratica.soggetto : null,
      tipoVisibilita: this.pratica?.tipoVisibilita ? this.pratica.tipoVisibilita : this.tipiVisibilitaOptions.find(el => el.label === 'PUBBLICA'),
      note: this.pratica ? this.pratica.note : '',
      oggetto: this.pratica ? this.pratica.oggetto : '',
      codice: this.pratica ? this.pratica.codice : '',
    });
    if(this.tipoPratica && this.tipoPratica.endpoint === TIPI_PRATICA.PENALE) {
      this.addPraticaPenaleField();
    }
    if (this.tipoPratica) {
      this.populateCodice();
    }
    this.selectedCodice = this.resolveCodice();
  }

  private resolveCodice(): Codice | null {
    const codiceObj = this.pratica?.codice;
    if (!codiceObj) {
      return null;
    }

    if (codiceObj.id) {
      return (
        this.codiceOptions?.find(o => o.id === codiceObj.id) ??
        codiceObj
      );
    }
    if (codiceObj.codice) {
      return this.codiceOptions?.find(
        o => o.codice === codiceObj.codice
      ) ?? null;
    }

    return null;
  }

  addPraticaPenaleField() {
    this.formGroup.addControl('tipoReato', new FormControl(null, Validators.required));
    this.formGroup.addControl('dataReato', new FormControl(null));
    this.formGroup.addControl('luogoReato', new FormControl(null));
    this.formGroup.addControl('dataIscrizioneNotiziaDiReato', new FormControl(null));
    this.formGroup.addControl('numeroNotiziaDiReato', new FormControl(null));
    this.formGroup.addControl('costituzioneParteCivile', new FormControl(null));
    this.formGroup.addControl('responsabileCivile', new FormControl(null));

    if(this.pratica){
      const praticaPenale = this.pratica as PraticaPenale;
      this.formGroup.patchValue({
        tipoReato: this.pratica ? praticaPenale.tipoReato : null,
        dataReato: this.pratica ? praticaPenale.dataReato : null,
        luogoReato: this.pratica ? praticaPenale.luogoReato : null,
        dataIscrizioneNotiziaDiReato: this.pratica ? praticaPenale.dataIscrizioneNotiziaDiReato : null,
        numeroNotiziaDiReato: this.pratica ? praticaPenale.numeroNotiziaDiReato : null,
        costituzioneParteCivile: this.pratica ? praticaPenale.costituzioneParteCivile : null,
        responsabileCivile: this.pratica ? praticaPenale.responsabileCivile : null,
        personaOffesa: this.pratica ? praticaPenale.personaOffesa : null,
      });
    }
  }

  private populateTipiVisibilita() {
    if (AppData.getInstance().tipiVisibilitaOptions.length > 0) {
      this.tipiVisibilitaOptions = AppData.getInstance().tipiVisibilitaOptions;
      this.checkTipoVisibilita();
    } else {
      this.helpers.getRolesByUserData().subscribe(
        () => {
          this.tipiVisibilitaOptions = AppData.getInstance().tipiVisibilitaOptions;
          this.checkTipoVisibilita();
        }
      )
    }
  }

  private populateCodice() {
  if (this.codiceOptions.length === 0 && this.tipoPratica) {
    this.helpers.getCodice(this.tipoPratica.id).subscribe(response => {
      this.codiceOptions = response;

      // Dopo aver popolato le opzioni, patcha il valore del campo
      const codiceResolved = this.resolveCodice();
      this.formGroup.patchValue({ codice: codiceResolved });
      this.selectedCodice = codiceResolved;
    });
  }
}

  private checkTipoVisibilita() {
    let riservato = this.tipiVisibilitaOptions.findIndex(x => x.label === 'RISERVATA') > -1;
    let riservatissimo = this.tipiVisibilitaOptions.findIndex(x => x.label === 'RISERVATISSIMA') > -1;
    if (!riservato && !riservatissimo) {
      this.tipiVisibilitaDisabled = true;
    }
  }

  getIdCodice() {
    const codiceObj = this?.pratica?.codice;
    if (codiceObj?.id) {
      return codiceObj;
    }
    else if (codiceObj?.codice && this.codiceOptions?.length > 0) {
      return this.codiceOptions.find(option => option.codice === codiceObj.codice);
    }
    return null;
  }

  updateCodice(event: any): void {
    if (event) {
      this.pratica.codice = event;
      this.formGroup.get('codice')?.setValue(event);
    } else {
      this.pratica.codice = null;
      this.formGroup.get('codice')?.setValue(null);
    }
  }

}
